module.exports = __webpack_public_path__ + "static/facts-bg-31708cfb38bbe08068d3a7ce92040811.jpg";